// extracted by mini-css-extract-plugin
export default {"wrapper":"Auth_wrapper__EjlOI","title":"Auth_title__if+V2","submit-error":"Auth_submit-error__bjBOm","next-form":"Auth_next-form__dECfD","link":"Auth_link__Vuctk"};